module.exports = __webpack_public_path__ + "img/en.b62a5866.svg";